import { restaurant, images } from "../data";
import { MapPin, Clock, Phone, Navigation, Truck } from "lucide-react";

function todayIndex() {
  // JS: 0 Sun..6 Sat ; our array is Mon..Sun (0..6)
  const d = new Date().getDay();
  return d === 0 ? 6 : d - 1;
}

export default function Info() {
  const today = todayIndex();
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(restaurant.mapsQuery)}&output=embed`;
  const routeHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(restaurant.mapsQuery)}`;

  return (
    <section id="info" data-testid="info-section" className="relative z-10 bg-[#141414] py-20 md:py-28 border-y border-white/10">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.3em] text-[#e05d36] font-semibold">Besuch uns</span>
          <h2 className="mt-3 font-display font-black text-4xl md:text-5xl text-[#f5f5f0]">Öffnungszeiten & Standort</h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          {/* Hours */}
          <div className="lg:col-span-5 rounded-2xl bg-[#1a1a1a] border border-white/10 p-7 md:p-8">
            <div className="flex items-center gap-3">
              <div className="grid place-items-center h-11 w-11 rounded-full bg-[#e05d36]/15 text-[#e05d36]"><Clock size={22} /></div>
              <h3 className="font-display font-bold text-xl text-[#f5f5f0]">Öffnungszeiten</h3>
            </div>
            <ul className="mt-6 space-y-1">
              {restaurant.hours.map((h, i) => (
                <li
                  key={h.day}
                  data-testid={`hours-${i}`}
                  className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm ${
                    i === today ? "bg-[#e05d36]/15 text-[#f5f5f0]" : "text-[#a3a3a3]"
                  }`}
                >
                  <span className={i === today ? "font-semibold" : ""}>
                    {h.day} {i === today && <span className="text-[#e05d36]">· heute</span>}
                  </span>
                  <span className="font-medium">{h.time}</span>
                </li>
              ))}
            </ul>
            <div className="mt-5 rounded-xl bg-[#242424] p-4">
              <div className="flex items-center gap-2">
                <Truck size={18} className="text-[#eab308] flex-shrink-0" />
                <span className="font-semibold text-sm text-[#f5f5f0]">Lieferzeiten</span>
              </div>
              <ul className="mt-2 space-y-1">
                {restaurant.deliveryHours.map((d) => (
                  <li key={d.day} className="flex items-center justify-between text-sm text-[#d4d4cf]">
                    <span>{d.day}</span>
                    <span className="font-medium">{d.time}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-2 text-xs text-[#a3a3a3]">{restaurant.delivery}</p>
            </div>
          </div>

          {/* Contact + Map */}
          <div className="lg:col-span-7 grid gap-6">
            <div className="grid sm:grid-cols-2 gap-6">
              <div className="rounded-2xl bg-[#1a1a1a] border border-white/10 p-7">
                <div className="grid place-items-center h-11 w-11 rounded-full bg-[#e05d36]/15 text-[#e05d36]"><MapPin size={22} /></div>
                <h3 className="mt-4 font-display font-bold text-lg text-[#f5f5f0]">Adresse</h3>
                <p className="mt-1 text-[#a3a3a3]">{restaurant.address}</p>
                <a href={routeHref} target="_blank" rel="noreferrer" data-testid="route-btn" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#e05d36] hover:gap-3 transition-all duration-200">
                  <Navigation size={16} /> Route planen
                </a>
              </div>
              <div className="rounded-2xl bg-[#1a1a1a] border border-white/10 p-7">
                <div className="grid place-items-center h-11 w-11 rounded-full bg-[#e05d36]/15 text-[#e05d36]"><Phone size={22} /></div>
                <h3 className="mt-4 font-display font-bold text-lg text-[#f5f5f0]">Telefon</h3>
                <p className="mt-1 text-[#a3a3a3]">Bestellung & Reservierung</p>
                <a href={restaurant.phoneHref} data-testid="info-call-btn" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#e05d36] hover:gap-3 transition-all duration-200">
                  <Phone size={16} /> {restaurant.phone}
                </a>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden border border-white/10 h-[280px]">
              <iframe
                title="Standort"
                data-testid="map-embed"
                src={mapSrc}
                className="h-full w-full"
                style={{ border: 0, filter: "grayscale(0.3) contrast(1.1)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
